import React from 'react'

import { arrayOf, shape, string } from 'prop-types'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

const IMAGE_WIDTH = 1080
const IMAGE_HEIGHT = 1296

function Gallery({ title = '', items = EMPTY_ARRAY, linkUrl = '', linkLabel = '' }) {
  if (!title || items.length === 0) return null

  return (
    <section className="ai-generator-landing__gallery" aria-labelledby="ai-generator-landing-gallery-title">
      <div className="ai-generator-landing__gallery-container">
        <h2 id="ai-generator-landing-gallery-title" className="ai-generator-landing__gallery-title cgt-heading-500">
          {title}
        </h2>
        <ul className="ai-generator-landing__gallery-grid">
          {items.map((item) => {
            const image = (
              <img
                className="ai-generator-landing__gallery-image"
                src={item.src}
                alt={item.alt}
                width={IMAGE_WIDTH}
                height={IMAGE_HEIGHT}
                loading="lazy"
                decoding="async"
              />
            )

            return (
              <li key={item.src} className="ai-generator-landing__gallery-item">
                {linkUrl ? (
                  <a className="ai-generator-landing__gallery-link" href={linkUrl}>
                    {image}
                    {linkLabel && (
                      <span className="ai-generator-landing__gallery-label cgt-button-text-base-semibold">
                        {linkLabel}
                      </span>
                    )}
                  </a>
                ) : image}
              </li>
            )
          })}
        </ul>
      </div>
    </section>
  )
}

Gallery.propTypes = {
  title: string,
  items: arrayOf(shape({ src: string.isRequired, alt: string })),
  linkUrl: string,
  linkLabel: string,
}

export default Gallery
